import { Box, Skeleton, useTheme } from '@mui/material';

export const LoadingSkeleton = ({ items = 4 }: { items?: number }) => {
  const itemsArray = Array.from({ length: items });
  const { spacing } = useTheme();
  return (
    <Box>
      {itemsArray.map((_, index) => (
        <Box key={`loading-skeleton-item-${index}`} margin={`${spacing(1)} 0`}>
          <Skeleton variant='rounded' height={40} />
        </Box>
      ))}
    </Box>
  );
};
